'use strict';

const React = require('react'),
  PropTypes = React.PropTypes,
  {t} = require('services/i18nextWrapper'),
  {merge} = require('lodash/object'),
  ContentUtils = require('utils/ContentUtils'),
  {map} = require('lodash/collection'),
  {debounce} = require('lodash/function'),
  Notification = require('components/Notification/Notification'),
  Breadcrumb = require('components/Commons/Breadcrumb/Breadcrumb'),
  BasicForm = require('./BasicForm'),
  FormGroupButton = require('./FormGroupButton/FormGroupButton');

const BasicFormNew = React.createClass({displayName: "BasicFormNew",

  mixins: [BasicForm],

  propTypes: Object.assign({}, BasicForm.propTypes, {
    additionalPreSubmitValidation: PropTypes.func,
    additionalWriterValue: PropTypes.object,
    contextHolder: PropTypes.object,
    children: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    onAddText: PropTypes.func,
    urlBack: PropTypes.string,
    isAddHidden: PropTypes.boolean,
    breadcrumb: PropTypes.array,
    isValid: PropTypes.bool,
    isSaving: PropTypes.bool,
    addEnterKeyDown: PropTypes.func
  }),

  componentDidMount() {
    const {addEnterKeyDown, shouldFocusDidMount} = this.props;

    // register to child
    if (addEnterKeyDown) {
      addEnterKeyDown(this._onAdd.bind(this));
    }

    if (shouldFocusDidMount) {
      const self = this;
      const elementFocusables = self.getDOMNode().querySelectorAll('.basic-form-fields div[tabindex="0"], .basic-form-fields input');
      if (elementFocusables && ContentUtils.isNotEmptyArray(elementFocusables)) {
        elementFocusables[0].focus(); // focus on first focusable element
      }
    }
  },

  _onAdd() {
    const {contextHolder, onAdd, additionalSubmitValue, additionalPreSubmitValidation} = this.props;
    if (this.isLoading) {
      Notification.show(t('dashboard_notification_please_wait_finish_process'));
    } else {
      if (contextHolder.isValid()) {
        this.isLoading = true;
        let item = contextHolder.getItem();
        if (additionalPreSubmitValidation && !additionalPreSubmitValidation(item)) {
          return;
        }
        if (additionalSubmitValue) {
          item = merge(item, additionalSubmitValue);
        }
        try {
          onAdd(item, this._onAddSuccess, this._onAddFailure);
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoading = false;
        }
      }
    }
  },

  _onAddSuccess(ajax) {
    const {contextHolder, fetchItems} = this.props;

    if (ajax.status >= 200 && ajax.status < 300) {
      Notification.show(this.props.messages.addSuccessMessage, 'success');
      fetchItems();
    } else {
      Notification.show(this.props.messages.addFailureMessage);
    }
    contextHolder.clean();
  },

  _onAddFailure() {
  },

  render() {
    const {title, children, additionalButtons, isAddHidden, breadcrumb, isValid, onAddText, isSaving} = this.props;
    const addText = onAddText ? onAddText : t('tank_buttom_label_create');

    const buttonNewEl = isAddHidden ? null : (
      React.createElement("div", {className: "basic-form-content pull-left"}, 
        React.createElement(FormGroupButton, {
          icon: "save", 
          className: "primary-icon", 
          type: "icon", 
          label: addText, 
          onClick: debounce(this._onAdd, 500), 
          disable: isSaving}
        )
      )
    );
    const additionalButtonsEl = additionalButtons ? map(additionalButtons, (button) =>
      React.createElement("span", {className: "basic-form-content additional-button pull-left"}, 
                button
            )
    ) : null;

    let className = 'basic-form-container container-fluid';

    if (!isValid) {
      className += ' is-invalid';
    }
    return (
      React.createElement("div", {className: className}, 
        
          breadcrumb ? (
            React.createElement("div", {className: "basic-form-breadcrumb"}, 
              React.createElement(Breadcrumb, {items: breadcrumb})
            )
          ) : null, 
        
        React.createElement("div", {className: "basic-form-header col-xs-12"}, 
          React.createElement("h1", null, title)
        ), 
        React.createElement("div", {className: "basic-form-fields"}, 
          children
        ), 
        React.createElement("div", {className: "basic-form-buttons"}, 
          additionalButtonsEl, 
          buttonNewEl
        )
      )
    );
  }
});

module.exports = BasicFormNew;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/BasicFormNew.jsx
 **/